window.Products.Material = {

};
window.Products.Material.Material = function() {
	
};
window.Products.Material.Material.inherits(window.Products.Product);

window.Products.Material.Material.dpi = 150;
window.Products.Material.Material.has_3d = true;